import Vue from 'vue';
import Router from 'vue-router';
import Home from '../views/Home.vue';
import Contacts from '../views/Contacts.vue';
import About from '../views/About.vue';
import Register from '../views/Register.vue';
import Login from '../views/Login.vue';
import AuthService from '../services/authentication-service';
import ToastrService from '../common/toastr-util';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: Contacts,
      beforeEnter(to, from, next) {
        const allowed = AuthService.isAuthenticated() && AuthService.userHasRole(['WebAdmin']);
        if (!allowed) {
          ToastrService.toast('error', 'You are not authorized to access that page');
          next(false);
        } else {
          next();
        }
      }
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/logout',
      name: 'logout',
      component: Login,
      async beforeEnter(to, from, next) {
        // Call next first
        await AuthService.logout();
        // next('/somewhereelse'); if you want to go somewhere else
        // since you are not really using the Login component
        next();
      }
    }
  ]
});
